import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "amount-difference-modal__question typographies-paragraph-medium-regular" }

import { computed, inject } from 'vue';

import { Translator } from 'types/injects/translator.type';

interface Props {
    lineTotal: string;
    ocrTotal: string;
    isTaxMode?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OcrAmountDifferenceModal',
  props: /*@__PURE__*/_mergeModels({
    lineTotal: {},
    ocrTotal: {},
    isTaxMode: { type: Boolean, default: false }
  }, {
    "visible": { type: Boolean, ...{ default: false } },
    "visibleModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["confirm", "cancel"], ["update:visible"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;

const visible = _useModel<boolean>(__props, 'visible');

const emit = __emit;

const $t = inject('$t') as Translator;

const alertDescription = computed<string>(() =>
    $t.__('ocr.OcrAmountDifferenceModal.alert', {
        lineTotal: props.lineTotal,
        ocrTotal: props.ocrTotal,
    }),
);

const whatToDoItems = computed<string[]>(() => {
    const items = [$t.__('ocr.OcrAmountDifferenceModal.option_edit_lines')];
    if (!props.isTaxMode) {
        items.push($t.__('ocr.OcrAmountDifferenceModal.option_switch_tax'));
    }
    return items;
});

const confirm = (): void => emit('confirm');
const cancel = (): void => emit('cancel');

return (_ctx: any,_cache: any) => {
  const _component_CompassCallout = _resolveComponent("CompassCallout")!
  const _component_CompassModal = _resolveComponent("CompassModal")!

  return (_openBlock(), _createBlock(_component_CompassModal, {
    visible: visible.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    title: _unref($t).__('ocr.OcrAmountDifferenceModal.title'),
    size: _ctx.CompassEnums.ModalSize.SMALL,
    primaryAction: {
            label: _unref($t).__('common.actions.validate'),
            type: _ctx.CompassEnums.ButtonType.PRIMARY,
            action: confirm,
        },
    secondaryActions: [
            {
                label: _unref($t).__('common.actions.cancel'),
                type: _ctx.CompassEnums.ButtonType.SECONDARY,
                action: cancel,
            },
        ],
    onClosed: cancel
  }, {
    default: _withCtx(() => [
      _createCommentVNode(" eslint-disable vue/no-v-html "),
      _createElementVNode("p", {
        class: "amount-difference-modal__description typographies-paragraph-medium-regular",
        innerHTML: alertDescription.value
      }, null, 8 /* PROPS */, _hoisted_1),
      _createCommentVNode(" eslint-enable vue/no-v-html "),
      _createVNode(_component_CompassCallout, {
        class: "amount-difference-modal__what-to-do",
        title: _unref($t).__('ocr.OcrAmountDifferenceModal.what_to_do'),
        icon: "success-circle-fill",
        items: whatToDoItems.value
      }, null, 8 /* PROPS */, ["title", "items"]),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_unref($t).__('ocr.OcrAmountDifferenceModal.confirm_question')), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["visible", "title", "size", "primaryAction", "secondaryActions"]))
}
}

})